import { render } from "./Infant.vue?vue&type=template&id=1e4531cc&scoped=true"
import script from "./Infant.vue?vue&type=script&lang=js"
export * from "./Infant.vue?vue&type=script&lang=js"

import "./Infant.vue?vue&type=style&index=0&id=1e4531cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4531cc"]])

export default __exports__